import { createFileRoute } from "@tanstack/react-router";
import { NotificationsPage } from "@/features/settings/you-pages";

export const Route = createFileRoute("/_app/settings/notifications")({ component: NotificationsPage });
